import { motion } from "framer-motion";
import { Terminal } from "lucide-react";
import { useLang } from "@/i18n";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="border-t border-[#28342C] bg-[#0D110E] px-4 sm:px-8 lg:px-16 pt-16 pb-8 overflow-hidden" data-testid="main-footer">
      <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-40px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="font-heading font-extrabold uppercase leading-none tracking-tight text-[13vw] lg:text-[10vw] text-stroke select-none"
      >
        Korpsecur
      </motion.h2>
      <div className="font-heading font-extrabold uppercase tracking-tight text-[#C8B48D] text-xl sm:text-3xl -mt-2 sm:-mt-4">
        {t.footer.role}
      </div>

      <div className="mt-12 pt-6 border-t border-[#28342C] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex items-center gap-2 font-mono2 text-[10px] tracking-[0.25em] text-[#5C6A60]" data-testid="footer-telemetry">
          <Terminal className="w-3.5 h-3.5 text-[#22C55E]" />
          ALL SYSTEMS OPERATIONAL // SECURE CONNECTION
        </div>
        <p className="font-mono2 text-[10px] tracking-[0.2em] text-[#5C6A60]">
          © {new Date().getFullYear()} KORPSECUR — {t.footer.disclaimer}
        </p>
      </div>
    </footer>
  );
};
